import React from 'react';
import {
  Button,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

export default function RoleListPanel({
  roleList,
  selectedRoleId,
  isNewRole,
  canManageRoles,
  onCreateRole,
  onSelectRole,
}) {
  return (
    <Paper variant="outlined" sx={{p: 2, height: '100%'}}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{mb: 2}}>
        <Typography variant="h6">Rollen</Typography>
        <Button variant="contained" size="small" onClick={onCreateRole} disabled={!canManageRoles}>
          Neue Rolle
        </Button>
      </Stack>
      <Divider sx={{mb: 2}} />
      {roleList.length === 0 ? (
        <Typography color="text.secondary">Noch keine Rollen vorhanden.</Typography>
      ) : (
        <List>
          {roleList.map((role) => (
            <ListItemButton
              key={role.id}
              selected={!isNewRole && selectedRoleId === role.id}
              onClick={() => onSelectRole(role)}
            >
              <ListItemText primary={role.name} secondary={role.description} />
            </ListItemButton>
          ))}
        </List>
      )}
    </Paper>
  );
}
